<!-- 课程资料列表 -->
<template>
  <a-table
    row-key="fileDownUrl"
    :loading="loading"
    :columns="columns"
    :data-source="tableList"
    :pagination="false"
  >
    <template slot="action" slot-scope="text, record">
      <a :href="record.fileDownUrl" download target="_self">下载</a>
    </template>
  </a-table>
</template>

<script>
import { reactive, toRefs, onMounted } from '@vue/composition-api'
import service from '@/service/courseAndGroup'

const columns = [
  {
    dataIndex: 'resourceTypeName',
    key: 'resourceTypeName',
    ellipsis: true,
    width: '32%',
    align: 'left',
    title: '名称'
  },
  {
    dataIndex: 'resourceTypeDesc',
    key: 'resourceTypeDesc',
    ellipsis: true,
    align: 'left',
    title: '注释',
    scopedSlots: { customRender: 'palyState' }
  },
  {
    title: '操作',
    width: 60,
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  name: 'CourseMaterials',

  props: {
    classTypeId: [Number, String]
  },

  setup(props) {
    const state = reactive({
      loading: false,
      tableList: []
    })

    const methods = {
      initList: () => {
        if (!props.classTypeId) throw new Error('classTypeId参数有误')
        state.loading = true
        service.adminCourseMaterials({ classTypeId: Number(props.classTypeId) }).then(res => {
          state.tableList = res || []
        }).finally(() => {
          state.loading = false
        })
      }
    }

    onMounted(() => {
      methods.initList()
    })

    return {
      columns,
      ...methods,
      ...toRefs(state)
    }
  }
}
</script>